<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cd-main" aria-label="Group details">
    <mat-toolbar class="cd-header-toolbar">
      <button mat-icon-button (click)="goBack()" aria-label="Back to students">
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
      </button>

      @if (group()) {
        <div class="gp-header-avatar" aria-hidden="true">
          <mat-icon>{{ group()!.icon ? group()!.icon : 'groups' }}</mat-icon>
        </div>
        <div class="cd-header-left">
          <h1 class="cd-title">{{ group()!.name }}</h1>
          <span class="cd-subtitle">{{ sourceLabel() }} · {{ members().length }} members</span>
        </div>
      } @else {
        <div class="cd-header-left">
          <h1 class="cd-title">Group</h1>
        </div>
      }

      <span class="cd-toolbar-spacer" aria-hidden="true"></span>

      @if (group() && canManage()) {
        <button
          *hasPermission="permissions.GROUPS.EDIT"
          mat-stroked-button
          (click)="openEditGroup()"
          aria-label="Edit group details"
        >
          <mat-icon aria-hidden="true">edit</mat-icon>
          Edit group
        </button>
      }
    </mat-toolbar>

    @if (loading()) {
      <div class="gp-loading" role="status" aria-live="polite" aria-label="Loading group">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (error()) {
      <mat-card class="gp-error-card" role="alert">
        <mat-card-content class="gp-error-content">
          <mat-icon color="warn" aria-hidden="true">error_outline</mat-icon>
          <span>{{ error() }}</span>
        </mat-card-content>
      </mat-card>
    }

    @if (!loading() && !error() && group()) {
      <div class="gp-layout">
        <mat-card class="gp-main-card">
          <mat-card-header class="gp-card-header">
            <mat-card-title>About this group</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="gp-desc">
            <p>{{ group()!.description || 'No description added yet.' }}</p>
          </mat-card-content>
        </mat-card>

        <mat-card class="gp-main-card">
          <mat-card-header class="gp-card-header">
            <mat-card-title>Members</mat-card-title>
            <mat-card-subtitle>{{ members().length }} students</mat-card-subtitle>
          </mat-card-header>
          <mat-divider></mat-divider>

          @if (canManage()) {
            <div class="gp-add-member-row" *hasPermission="permissions.GROUPS.ADD_MEMBERS">
              <mat-form-field
                appearance="outline"
                class="gp-add-member-field"
                subscriptSizing="dynamic"
              >
                <mat-label>Add student</mat-label>
                <mat-select [(ngModel)]="pendingAddStudentId" aria-label="Select a student to add">
                  @for (s of availableStudents(); track s.id) {
                    <mat-option [value]="s.user.id">
                      {{ s.user.preferred_name || s.user.first_name }} {{ s.user.last_name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <button mat-flat-button [disabled]="!pendingAddStudentId" (click)="addMember()">
                Add
              </button>
            </div>
          }

          <mat-card-content class="gp-member-list-wrap">
            @if (members().length === 0) {
              <div class="gp-empty" role="status">
                <mat-icon aria-hidden="true">group_off</mat-icon>
                <span>No members yet.</span>
              </div>
            } @else {
              <mat-list class="gp-member-list" aria-label="Group members">
                @for (s of members(); track s.id) {
                  <mat-list-item>
                    <div matListItemIcon aria-hidden="true" class="cd-student-avatar">
                      <app-user-avatar
                        [imageUrl]="s.Profile?.profile_picture_path"
                        [name]="s.user.first_name + ' ' + s.user.last_name"
                      />
                    </div>
                    <span matListItemTitle
                      >{{ s.user.preferred_name || s.user.first_name }} {{ s.user.last_name }}</span
                    >
                    <span matListItemLine>{{ gradeLabel(s.grade_level) }}</span>
                    @if (canManage()) {
                      <button
                        *hasPermission="permissions.GROUPS.REMOVE_MEMBERS"
                        matListItemMeta
                        mat-icon-button
                        (click)="removeMember(s.user.id)"
                        aria-label="Remove from group"
                      >
                        <mat-icon aria-hidden="true">close</mat-icon>
                      </button>
                    }
                  </mat-list-item>
                  <mat-divider inset></mat-divider>
                }
              </mat-list>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }
  </main>
</div>
